<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { ButtonIcon } from '@caks/uikit/button'
import { IconArrow } from '@caks/uikit/icon'

interface Props {
  gap: string
  height: string
  itemWidth?: string
  button?: boolean
  desktop?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  button: false,
  desktop: false,
})
const w = computed(() => props.itemWidth ?? props.height)

const scrollContainer = ref<HTMLElement | null>(null)
const showButton = ref(false)

const checkOverflow = () => {
  if (scrollContainer.value) {
    showButton.value = scrollContainer.value.scrollWidth > scrollContainer.value.clientWidth
  }
}

const scrollRight = () => {
  if (scrollContainer.value) {
    scrollContainer.value.scroll({
      left: scrollContainer.value.scrollLeft + 155,
      behavior: 'smooth',
    })
  }
}

watch(scrollContainer, checkOverflow, { immediate: true })
</script>

<template>
  <div ref="scrollContainer" class="track">
    <slot />
    <div v-if="desktop" style="width: 142px"></div>
    <div class="track__wrapper">
      <div v-if="desktop && showButton" class="track__button">
        <button-icon @click="scrollRight" state="large-circle" :icon="IconArrow" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.track {
  overflow-x: scroll;
  overflow-y: hidden;
  min-width: 100%;
  display: flex;
  gap: v-bind(gap);
  height: v-bind(height);
  min-height: 34px;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-color: transparent transparent;

  &:deep(> *) {
    width: v-bind(w);
    min-width: v-bind(w);
    max-width: v-bind(w);
  }

  &__wrapper {
    position: absolute;
    max-width: min(1312px, calc(100vw - 12px));
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    pointer-events: none;
  }

  &__button {
    position: absolute;
    height: calc(v-bind(height) - 18px);
    right: 0;
    top: 0;
    padding: 0 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    background: linear-gradient(270deg, #fafafa 0%, rgba(250, 250, 250, 0) 100%);
  }
}
</style>
